function inviteGuestsDialogDirective () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/invite-guests/invite-guests-dialog.html?$$REVISION$$'
  }
}

export { inviteGuestsDialogDirective }
